export default function (state = [], action) {
    switch (action.type) {
        case "EMPLOYEE_WORK_SHIFTS_CHANGED":
            return action.data
        default:
            return state
    }
}
